import { kebabCase } from 'lodash'

import { FaqEntryModel } from '../types/help-center-faq-entry-model'
import { HelpCenterFaqEntryRubyModel } from '../types/help-center-faq-entry-ruby-model'
import { HelpCenterFaqEntryRubyDto } from '../types/help-center-faq-entry-ruby-dto'
import { HelpCenterQuestionModel } from '../types/help-center-question'

export const transformHelpCenterFaqEntryChildren = (
  { children }: FaqEntryModel,
  accessChannel: string,
  faqEntryParentId?: number | null,
  transactionId?: string,
): Array<HelpCenterQuestionModel> | null => {
  if (!children?.length) return null
  const pathPrefix = faqEntryParentId ? `/help/${faqEntryParentId}` : '/help'

  return children.map(({ id, title }) => {
    const mainPath = `${pathPrefix}/${kebabCase(`${id}-${title}`)}?access_channel=${accessChannel}`
    const path = transactionId ? `${mainPath}&transaction_id=${transactionId}` : mainPath

    return { id, title, path }
  })
}

// Note: (ember) Potentially to be cleaned up
export const transformHelpCenterFaqEntryRubyDto = (
  faqEntry: HelpCenterFaqEntryRubyDto,
): HelpCenterFaqEntryRubyModel => ({
  id: faqEntry.id,
  title: faqEntry.title,
  code: faqEntry.code,
  proceedButton: faqEntry.proceed_button,
  isContactAllowed: faqEntry.contact_allowed,
  isAnonymousAllowed: faqEntry.anonymous_allowed,
  isTransactionRequired: faqEntry.transaction_required,
  isComplaintsFaq: faqEntry.delays_ticket,
})
